import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    toggleMenu: (state) => !state,
  },
});

export const { toggleMenu } = menuSlice.actions;
export default menuSlice.reducer;